import store from "@/store";
import { formatDecimal } from "./order";

export const selectedSymbolData = (symbol) => {
  const allSymbol = store.state.transact.allSymbolData;
  const isBitget = store.state.transact.isBitget;
  const coinPrice = store.state.transact.coinPrice;
  const selectedSymbol = allSymbol.find(
    (s) => s.symbol === `${symbol}USDT`
  );
  if(!selectedSymbol) return;
  let symbolData;
  if (isBitget) {
    symbolData = {
      symbol: selectedSymbol.symbol, // 심볼
      pricePrecision: Number(selectedSymbol.pricePlace), // 가격 소수점 자리수
      quantityPrecision: Number(selectedSymbol.volumePlace), // 수량 소수점 자리수
      priceTickSize: (1 / 10 ** selectedSymbol.pricePlace).toString(), // 가격 틱 단위
      limitMinQty: selectedSymbol.minTradeNum || "0", // 지정가 최소 수량
      marketMinQty: selectedSymbol.minTradeNum || "0", // 시장가 최소 수량 (Bitget은 따로 없음)
      minNotional: selectedSymbol.minTradeUSDT || "0", // 최소 주문 금액 (USDT)
      minPrice: formatDecimal(coinPrice * 0.9, 4),
      maxPrice: formatDecimal(coinPrice * 1.1, 4),
    };
  } else {
    const priceFilter = selectedSymbol.filters.find(
      (f) => f.filterType === "PRICE_FILTER"
    );
    const lotSizeFilter = selectedSymbol.filters.find(
      (f) => f.filterType === "LOT_SIZE"
    );
    const marketLotSizeFilter = selectedSymbol.filters.find(
      (f) => f.filterType === "MARKET_LOT_SIZE"
    );
    const minNotionalFilter = selectedSymbol.filters.find(
      (f) => f.filterType === "MIN_NOTIONAL"
    );
    symbolData = {
      symbol: selectedSymbol.symbol, //무슨 심볼인지
      pricePrecision: selectedSymbol.pricePrecision, //금액 소수점 표기
      quantityPrecision: selectedSymbol.quantityPrecision, //수량 소수점 표기
      priceTickSize: priceFilter?.tickSize || "0.01", //주문 가능한 가격 단위
      limitMinQty: lotSizeFilter?.minQty || "0", //지정가주문 최소수량
      marketMinQty: marketLotSizeFilter?.minQty || "0", //시장가주면 최소수량
      minNotional: minNotionalFilter?.notional || "0", //주문 최소금액
      minPrice: priceFilter?.minPrice || "0", //price 최저가
      maxPrice: priceFilter?.maxPrice || "10000", //price 최대가
    };
  }
  return symbolData;
};
